module.exports = __webpack_public_path__ + "assets/img/02.0f2643e4.png";